import { render, staticRenderFns } from "./import-not-system-customer.vue?vue&type=template&id=c5057c54&"
import script from "./import-not-system-customer.vue?vue&type=script&lang=js&"
export * from "./import-not-system-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports